/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTaskCommandResult } from '../../models/create-task-command-result';
import { TaskCategory } from '../../models/task-category';

export interface ApiTaskCreateTaskPost$Params {
      body?: {
'Subject'?: string;
'Description'?: string;
'StakeholderId'?: number;
'EndDate'?: string;
'AdditionalDetails'?: string;
'TaskCategory': TaskCategory;
'Attachments'?: Array<Blob>;
'MeetingId'?: string;
'ResponsibleIds'?: Array<string>;
'CopyToList'?: Array<string>;
}
}

export function apiTaskCreateTaskPost(http: HttpClient, rootUrl: string, params?: ApiTaskCreateTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskCreateTaskPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateTaskCommandResult>;
    })
  );
}

apiTaskCreateTaskPost.PATH = '/api/Task/CreateTask';
